import { get } from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { formData } from '../../../../constants/actions'
import withColorSetting from '../../../../hoc/withColorSettings'
import {
  getCountry,
  getCurrentRegistration,
  getDefaultQuestions,
  getFormAgeRestriction,
  getFormId,
  getFormInfo,
  getFormSettings,
  getFormTimezone,
  getFormType,
  getFormValidationRule,
  getMemberTypes,
  getUser,
  getUserId,
} from '../../../../selectors'
import BasicInfoComponent from './component'

const mapStateToProps = state => ({
  currentRegistration: getCurrentRegistration(state),
  memberTypes: getMemberTypes(state),
  questions: getDefaultQuestions(state),
  userId: getUserId(state),
  form: getFormId(state),
  defaultCountry: getCountry(state),
  validationRules: getFormValidationRule(state),
  ageRestriction: getFormAgeRestriction(state),
  formType: getFormType(state),
  email: getUser(state).email,
  formSettings: getFormSettings(state),
  formInfo: getFormInfo(state),
  members: get(state, 'formInfo.members', []),
  timezone: getFormTimezone(state),
})

export default withRouter(
  connect(mapStateToProps, {
    clearParticipant: formData.clearParticipant,
    setValue: formData.setValues,
    selectParticipant: formData.selectParticipant,
  })(withColorSetting(BasicInfoComponent))
)
